import React from "react";
import { useApp } from "@/context/AppContext";

// Renders an internal USD amount ($1 = 1 credit) in the member's active display currency
// (local fiat by default, or a crypto from our list). No USD default: the small sub-line
// shows the local-currency equivalent when the primary figure is a crypto.
export function Price({
  usd,
  primaryClass = "",
  subClass = "text-[11px] text-sec",
  inline = false,
  showSub = true,
}) {
  const { currency, cryptos, cryptoPrices, meta, localCurrency, fmtMoney } = useApp();
  const n = Number(usd) || 0;
  const wrap = inline ? "inline-flex items-baseline gap-1.5" : "inline-flex flex-col leading-tight";

  const primary = fmtMoney(n);
  const isCrypto = !!cryptos?.[currency];

  // Sub-line: local-currency equivalent (only meaningful when the primary is a crypto).
  let sub = "";
  if (isCrypto && localCurrency) {
    const fx = meta?.currencies?.[localCurrency];
    sub = fx && localCurrency !== "USD" ? `${fx.symbol}${Math.round(n * fx.rate).toLocaleString()}` : `$${Math.round(n).toLocaleString()}`;
  }

  return (
    <span className={wrap} data-testid={isCrypto ? "price-crypto" : "price-fiat"}>
      <span className={primaryClass}>{primary}</span>
      {showSub && sub && <span className={subClass}>{sub}</span>}
    </span>
  );
}
